import React, { useState, useCallback, useEffect } from "react";
import { InsuranceRequirement, JonesRecord, Project, PermissionOptionModel } from "../../models"
import API from "../../apis";
import { showErrorMessage, showSuccessMessage } from "../../utils";
import SuccessIcon from "../../shared/SuccessIcon";

export function useLoad() {
  const [jonesVendor, setJonesVendor] = useState<JonesRecord[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [downloading, setDownLoading] = React.useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingJonesVendors, setLoadingJonesVendors] = useState(false);
  const [permissions, setPermissions] = useState<PermissionOptionModel[]>([])
  const [Coifileload, setCoifileload] = useState<boolean>(false);


  const [project, setProject] = useState<Project>({
    id: 0,
    name: "",
    code: "",
    vendorList: [],
    requirementList: [],
    projectRoles: [],
    clientId: 0,
    kriyagoProjectId: 0,
    requirements: [],
    logeduser: "",
    comanyAccName :"",
  });

  const [insurance, setInsurance] = useState<InsuranceRequirement>({
    vendors: [],
    projectId: 0,
    requirementId: null,
    clientId: 0,
    kriyagoProjectId: 0,
    companyId: '0',
    tabId: 0,
  });  

  const onLoadCoiFiles = useCallback(
    async (ForeignId2: string, Id: any) => {

      try {

        setLoadingUsers(true);
        const response = await API.get(
          `Procore/GetRecentCoiFile?ForeignId2=${ForeignId2}&Id=${Id}`,
        );
        if (response && response.data) {
          return response.data;
        }
        else { return null; }

      } catch (e) {
        console.log(e);

        setErrorMessage(e.message);
      }
    },
    []
  );


  const onUploadCoiFiles = useCallback(
    async (values, ForeignId2: string, Id: any,objectid:number) => {      
      setCoifileload(true)
      try {
        

        let formData = new FormData();
        for (var i = 0; i < values.length; i++) {
          const element = values[i].file;
          formData.append(`files`, element);
        }
        const response = await API.post(
          `Procore/UploadCoiFile?ForeignId2=${ForeignId2}&Id=${Id}`, formData
        );
        onLoadJonesVendors(objectid);
        setCoifileload(false)
      
        
        if (response.data == true) {     

          showSuccessMessage(
            "Insurance docs have been uploaded",
            <SuccessIcon />
          );
         } else {
          showErrorMessage("File is incorrect");
        }
        return response.data;
      } catch (e) {
        console.log(e);
        setLoadingUsers(false);
        setErrorMessage(e.message);
      }
    },
    []
  );


  const onLoadJonesVendors = useCallback(
    async (objectid: number = 0) => {
      setLoadingJonesVendors(true);
      try {
        const projectId = new URLSearchParams(window.location.search).get("ProjectID");
        let companyId = new URLSearchParams(window.location.search).get("CompanyID");
        const response = await API.get(`Procore/GetJonesVendors?projectId=${projectId}&CompanyId=${companyId?.toString()}&search=${""}&mode=${"global"}&objectid=${objectid}`);
        setJonesVendor(response.data);
        setLoadingJonesVendors(false);
        return response.data;

      } catch (e) {
        setLoadingJonesVendors(false);
      }
    }, []
  )



  const onLoadPermissions = React.useCallback(async () => {
    let companyId = new URLSearchParams(window.location.search).get(
      "CompanyID"
    );
    let projectId = new URLSearchParams(window.location.search).get(
      "ProjectID"
    );
    try {
      const response = await API.get(`Procore/GetPermissionTemplates?companyId=${companyId?.toString()}&projectId=${projectId}`);
      if (response.data) {
        setPermissions([
          {
            label: "",
            options: [
              {
                id: 0,
                type: "",
                name: "Apply Permission Template Later",
                projectSpecific: false
              }
            ]
          },
          ...response.data
        ])
      }
    } catch (error) {
      console.log(error);
    }
  }, [])

//   useEffect(() => {
   
//     onLoadJonesVendors();
//     onLoadPermissions();
//   }, [onLoadJonesVendors, onLoadPermissions])

  return {
    project,
    insurance,
    loading,
    setInsurance,
    errorMessage,
    jonesVendor,
    onLoadJonesVendors,
    downloading, 
    loadingUsers,
    setLoadingUsers,  
    loadingJonesVendors,
    permissions,
    onLoadCoiFiles,
    onUploadCoiFiles,
    Coifileload,

  }
}

